export const MeetTheTeamData = [
  {
    image: 'images/Michael.jpg',
    name: 'Michael Rango',
    position: 'IT HelpDesk Associate',
    description:
      '“Every day is different! I could be tracking inventory of every computer at headquarters, connecting with vendors to resolve an issue or learn about new services.”',
    url: 'https://www.instagram.com/p/CX_ahntrqqX/',
  },
  {
    image: 'images/Hector.jpg',
    name: 'Hector Camacho',
    position: 'Head of People, Retail Teams',
    description:
      '“The most rewarding part of my job is fostering that sense of community and belonging and making sure our team feels cared for, supported, rewarded, and celebrated for their hard work.”',
    url: 'https://www.instagram.com/p/CVnkIsXL8WY/',
  },
  {
    image: 'images/Jenny.jpg',
    name: 'Jenny Kim',
    position: 'Design Director, Packaging',
    description:
      "“A big part of the creative process that doesn't get a lot of recognition is the finessing stage. For every experience we create, we go through rounds and rounds of physical sampling until every element - from texture to material to color - is just right.”",
    url: 'https://www.instagram.com/p/CW81ysFvQzT/',
  },
];
